import LightTooltip from 'Components/LightTooltip'
import theme from 'Util/theme'
import InfoIcon from '@mui/icons-material/Info'
import { IconButton } from '@mui/material'

interface InfoTooltipProps {
  title: React.ReactNode
}

function InfoTooltip({ title }: Readonly<InfoTooltipProps>) {
  return (
    <LightTooltip title={title}>
      <IconButton sx={{ padding: 0 }}>
        <InfoIcon sx={{ color: theme.palette.secondary.main }} />
      </IconButton>
    </LightTooltip>
  )
}

export default InfoTooltip
